import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function QcGuideArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-qc-guide"]} />;
}